module.exports = __webpack_public_path__ + "img/lock_open.c808eab6.svg";